import { Routes, RouterModule }  from '@angular/router';
import { Pages } from './pages.component';
import { ModuleWithProviders } from '@angular/core';
import { AuthGuard } from '../providers/auth-guard.service';
import { RoleAgentGuard } from '../providers/roleagent.guard';
import { RoleAdminGuard } from '../providers/roleadmin.guard';
// noinspection TypeScriptValidateTypes

// export function loadChildren(path) { return System.import(path); };

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: 'app/pages/login/login.module#LoginModule'
  },
  {
    path: 'register',
    loadChildren: 'app/pages/register/register.module#RegisterModule'
  },
  {
    path: 'pages',
    component: Pages,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'offer/:id', canActivate: [], loadChildren: './offer/offer.module#OfferModule' },
      { path: 'listing/:id', loadChildren: './listing/listing.module#ListingModule' },
      { path: 'mylistings', canActivate: [RoleAgentGuard], loadChildren: './mylistings/mylistings.module#MyListingsModule' },
      { path: 'admin', canActivate: [RoleAdminGuard], loadChildren: './admin/admin.module#AdminModule' },
      { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule' },
      { path: 'editors', loadChildren: './editors/editors.module#EditorsModule' },
      { path: 'components', loadChildren: './components/components.module#ComponentsModule' },
      { path: 'charts', loadChildren: './charts/charts.module#ChartsModule' },
      { path: 'ui', loadChildren: './ui/ui.module#UiModule' },
      { path: 'forms', loadChildren: './forms/forms.module#FormsModule' },
      { path: 'tables', loadChildren: './tables/tables.module#TablesModule' },
      { path: 'maps', loadChildren: './maps/maps.module#MapsModule' }
    ]
  }
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/pages/pages.routing.ts